// src/pages/Accounts/incomeThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getIncomeWithDetailsApi,
  getIncomeCodeApi,
  saveIncomeApi,
  deleteIncomeApi,
} from "../../apiservice/accounts";
import { getAccountBySeachApi } from "../../apiservice/setting";

// fetch list (with details)
export const fetchIncomes = createAsyncThunk(
  "incomes/fetchIncomes",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getIncomeWithDetailsApi({ oneDate: null });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// fetch new income code
export const fetchIncomeCode = createAsyncThunk(
  "incomes/fetchIncomeCode",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getIncomeCodeApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchHeadAccs = createAsyncThunk(
  "lookups/fetchHeadAccs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
      multiType: ["indirect_income", "direct_income"],
    });     
      return res.data?.length > 0 ? res.data : null;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// save income (create / update)
export const saveIncome = createAsyncThunk(
  "incomes/saveIncome",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveIncomeApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// delete income
export const deleteIncome = createAsyncThunk(
  "incomes/deleteIncome",
  async (inc_id, { rejectWithValue }) => {
    try {
      const res = await deleteIncomeApi({ inc_id });
      return { id: inc_id, msg: res.data.msg };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


